/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-31
 */

import { Component, ElementRef, HostListener, ViewEncapsulation  } from '@angular/core';
import { ProgressService } from 'src/refresh/service/progress-service';
import { PageConstComponent } from '../component/page-const.component';
import { GAData } from '../constant/page-const';
import { InputData } from '../data/input-data';

@Component({
  selector: 'vision-progress',
  templateUrl: './progress_bar.component.html',
  styleUrls: ['./progress_bar.component.less'],
   encapsulation: ViewEncapsulation.None
})
export class ProgressBarComponent extends PageConstComponent {

          ///isOpened:boolean = false;
          constructor(public progress: ProgressService, private data:InputData, private elRef:ElementRef) { super();  }

          public ngOnInit(): void {

            let element = document.getElementById("popup_menu");
            element.addEventListener('click', el => {

                 ///if ( "LIGHT-BOX"  != el.target.parentElement.nodeName ) return;
                 //this.isOpened = false;  
                 this.onMenuSelected();
                 el.stopPropagation();
                 el.preventDefault();
            });

     }


          public onProgressMenu() {

               this.progress.greyedOut();
               let  content  = this.elRef.nativeElement.querySelector('.'+"inner-menu");
               setTimeout(function(){ 
                  content.scrollIntoView({behavior: "smooth"});
                  content.focus();
               }, 200);
               this.progress.isOpened = true;
               super.gtag(GAData.Link,GAData.Progress_Bar);
          }   

          public onMenuSelected() {
                 this.progress.isOpened = false;  
          }

          public keyPress(event:any) {
            if ( event.keyCode == 13 ) {
                  if(!this.progress.isOpened) {
                        this.onProgressMenu();    
                  } else{
                        this.onMenuSelected();
                  }    
            }
          }

           @HostListener('document:keydown.escape', ['$event'])
           public escape(){
            if(this.progress.isOpened) {
                  this.onMenuSelected();
           }
      }
}

